import { makeStyles, tokens } from "@fluentui/react-components";
/**
 * Styles for the Planner modal layers using Fluent UI v9 makeStyles
 */ export const usePlannerModalLayersStyles = makeStyles({
    emptyModal: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "200px",
        minWidth: "300px",
        padding: tokens.spacingVerticalXXL,
        flex: "1"
    }
});
